import React, { useRef } from 'react';
import { motion, MotionValue, useScroll, useTransform } from 'framer-motion';
import { aside, manifesto } from '../content';
import { Reveal } from './Reveal';

function Word({
  children,
  progress,
  range,
  serif,
}: {
  children: string;
  progress: MotionValue<number>;
  range: [number, number];
  serif: boolean;
}) {
  const opacity = useTransform(progress, range, [0.14, 1]);
  return (
    <motion.span className={serif ? 'serif' : undefined} style={{ opacity }}>
      {children}{' '}
    </motion.span>
  );
}

/** A paragraph that lights up word by word as it scrolls past. */
export function Manifesto() {
  const ref = useRef<HTMLParagraphElement>(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start 0.85', 'end 0.55'] });
  // Words between *asterisks* are set in serif italic.
  let italic = false;
  const words = manifesto.split(' ').map((raw) => {
    if (raw.startsWith('*')) italic = true;
    const word = { text: raw.replace(/\*/g, ''), serif: italic };
    if (raw.endsWith('*')) italic = false;
    return word;
  });

  return (
    <section id="about" className="manifesto wrap">
      <div className="section-head mono">
        <span>(01)</span>
        <span>About</span>
      </div>
      <div className="manifesto__grid">
        <ul className="manifesto__aside mono">
          {aside.map((line, i) => (
            <li key={line}>
              <Reveal delay={i * 0.08}>{line}</Reveal>
            </li>
          ))}
        </ul>
        <p ref={ref} className="manifesto__text" aria-label={manifesto.replace(/\*/g, '')}>
          <span aria-hidden="true">
            {words.map((word, i) => (
              <Word
                key={i}
                progress={scrollYProgress}
                range={[i / words.length, (i + 1) / words.length]}
                serif={word.serif}
              >
                {word.text}
              </Word>
            ))}
          </span>
        </p>
      </div>
    </section>
  );
}
